import { render } from "./Calendar.vue?vue&type=template&id=ca56eec0"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "ca56eec0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca56eec0', script)) {
    api.reload('ca56eec0', script)
  }
  
  module.hot.accept("./Calendar.vue?vue&type=template&id=ca56eec0", () => {
    api.rerender('ca56eec0', render)
  })

}

script.__file = "src/icons/components/outlined/Calendar.vue"

export default script